import {
  Injectable,
  Inject,
  PLATFORM_ID,
  Renderer2,
  RendererFactory2,
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { BehaviorSubject } from 'rxjs';
import { DevicesEnum } from '@src/app/enums';

@Injectable({
  providedIn: 'root',
})
export class DeviceService {
  private readonly deviceTypeSubject = new BehaviorSubject<DevicesEnum>(
    DevicesEnum.DESKTOP,
  );
  public readonly deviceType$ = this.deviceTypeSubject.asObservable();

  private renderer: Renderer2;
  private destroyResizeListener?: () => void;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private rendererFactory: RendererFactory2,
  ) {
    this.renderer = this.rendererFactory.createRenderer(null, null);

    if (isPlatformBrowser(this.platformId)) {
      this.updateDeviceType(window.innerWidth);

      this.destroyResizeListener = this.renderer.listen(
        'window',
        'resize',
        (event) => {
          const width = (event.target as Window).innerWidth;

          this.updateDeviceType(width);
        },
      );
    }
  }

  private updateDeviceType(width: number): void {
    // if (width < 768) {
    //   this.deviceTypeSubject.next(DevicesEnum.MOBILE);
    // } else if (width < 1025) {
    //   this.deviceTypeSubject.next(DevicesEnum.TABLET);
    // } else {
    //   this.deviceTypeSubject.next(DevicesEnum.DESKTOP);
    // }

    if (width > 1024) {
      this.deviceTypeSubject.next(DevicesEnum.DESKTOP);
    } else if (width < 1025) {
      this.deviceTypeSubject.next(DevicesEnum.TABLET);
    } else {
      this.deviceTypeSubject.next(DevicesEnum.MOBILE);
    }
  }

  ngOnDestroy() {
    this.destroyResizeListener?.();
  }
}
